import { RefObject, useEffect, useState } from 'react';

const SCROLL_DELAY = 300; // Needs to be delayed to complete state updates and animations before calculating y distance difference
const SCROLL_OFFSET = 100;

export const scrollToTop = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((process as any).browser) {
    window?.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  }
};

export const scrollElementIntoView = (scrollToReference: RefObject<HTMLElement | null>) =>
  scrollToReference?.current?.scrollIntoView({ behavior: 'smooth' });

export const useScrollToTopOnLoad = () => {
  const [initialLoad, setInitialLoad] = useState<boolean>(true);
  useEffect(() => {
    if (!initialLoad) {
      return;
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    setInitialLoad(false);
  });
};

export const useScrollElementToTop = (
  scrollToReference: RefObject<HTMLElement | null>,
  cacheBuster: unknown,
  pageHasHeader = true
) => {
  useEffect(
    function scrollElementToTop() {
      const scrollTimeout = setTimeout(() => {
        if (scrollToReference?.current) {
          const scrollDistance =
            scrollToReference.current.getBoundingClientRect().top - (pageHasHeader ? SCROLL_OFFSET : 0);
          globalThis?.scrollBy({ behavior: 'smooth', top: scrollDistance });
        }
      }, SCROLL_DELAY);

      return () => clearTimeout(scrollTimeout);
    },
    [cacheBuster]
  );
};
